import { NextContentResponse } from '@panda/cache/src/question/define';
import { HOMEWORK_LEARN_STATUS } from '@panda/cache/src/course/define';
import { UnitContentType } from '@panda/cache/src/unitResource/define';

/**
 * @class NC 从头开始做题还是继续上课
 * @description const nc = new NC()
 * @description nc.update({...data})//更新data data:{}
 * @description nc.open()//打开弹框
 * @description nc.close()//关闭弹框
 */

const template = `
    <style>
        .u-modal {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            background: rgba(0, 0, 0, 0.7);
            z-index: 52;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

        }

        .u-modal__dialog {
            background: #ffffff;
            border-radius: 32px;
            width: 560px;
            min-height: 324px;
            padding: 23px 36px 40px;
            box-sizing: border-box;
        }

        .u-modal__header {
            padding-top: 22px;
            padding-bottom: 24px;
            position: relative;
        }

        .u-modal__header::before {
            content: '';
            position: absolute;
            bottom: 0;
            background-image: url('https://edu-image.nosdn.127.net/04108d3380674479b36e77e005525f5d.png');
            background-repeat: no-repeat;
            background-position: center;
            width: 140px;
            height: 150px;
        }

        .u-modal__close {
            position: absolute;
            top: -48px;
            right: -100px;
            width: 48px;
            height: 48px;
        }

        .u-modal__close-icon {
            cursor: pointer;
            width: 100%;
            height: 100%;
        }

        .u-modal__title {
            font-size: 28px;
            color: #ff5868;
            text-align: center;
            height: 32px;
            line-height: 32px;
            font-weight: bold;
        }

        .u-modal__content {
            background: #fff6f7;
            border-radius: 28px;
            min-height: 100px;
            font-size: 20px;
            color: #333333;
            line-height: 32px;
            padding: 34px 0;
            text-align: center;
            box-sizing: border-box;
        }

        .u-modal__footer {
            margin-top: 24px;
            display: flex;
            justify-content: space-around;
        }

        .u-modal__cancel-button {
            width: 200px;
            height: 60px;
            font-size: 24px;
            color: #ff5868;
            border: 3px solid #ff5868;
            border-radius: 32px;
            background: #fff;
            cursor: pointer;
        }

        .u-modal__ok-button {
            width: 200px;
            height: 60px;
            background: #ff5868;
            font-size: 24px;
            color: #ffffff;
            border: 3px solid #ff5868;
            border-radius: 32px;
            cursor: pointer;
        }

        .u-modal__link {
            color: #ff5868;
        }
    </style>
    <div class="u-modal ">
        <div class="u-modal__dialog">
            <div class="u-modal__header">
                <div class="u-modal__close" style="display: none;"><img src="" class="u-modal__close-icon"></div>
                <div class="u-modal__title">小卡搭提醒</div>
            </div>
            <div class="u-modal__body">
                <div class="u-modal__content">准备好继续答题了么~</div>
            </div>
            <div class="u-modal__footer">
                <button class="u-modal__cancel-button">重新开始 </button>
                <button class="u-modal__ok-button"> 继续作答 </button>
            </div>
        </div>
    </div>
    `;

export default class NC {
  container: any = null;

  nextContent: NextContentResponse = {} as NextContentResponse;

  constructor(nextContent?: NextContentResponse) {
    if (nextContent) {
      this.nextContent = nextContent;
    }
    this.render();
    this.listen();
  }

  render() {
    this.container = document.createElement('div');
    this.container.innerHTML = template;
  }

  listen() {
    const btnRestart = this.container.querySelector('.u-modal__cancel-button');
    const btnContinue = this.container.querySelector('.u-modal__ok-button');
    btnRestart.addEventListener('click', () => {
      this.handleClickRestart();
    });
    btnContinue.addEventListener('click', () => {
      this.handleClickContinue();
    });
  }

  update(nextContent: NextContentResponse) {
    this.nextContent = nextContent;
    return this;
  }

  // 显示弹框
  open() {
    document.body.appendChild(this.container);
    return this;
  }

  close() {
    this.container.remove();
    return this;
  }

  // 从头开始
  handleClickRestart() {
    console.log('btnRestart', this);
    if (this.nextContent) {
      this.toWork(HOMEWORK_LEARN_STATUS.NOT_COMPLETE);
    }
  }

  // 继续上课
  handleClickContinue() {
    console.log('btnContinue');
    if (this.nextContent) {
      this.toWork(HOMEWORK_LEARN_STATUS.COMPLETE_WITH_ERRORS);
    }
  }

  toWork(type: HOMEWORK_LEARN_STATUS) {
    window.location.href = `${this.nextContent.homeworkUrl}?homeworkId=${this.nextContent.unitId}&type=${type}`;
    this.close();
  }

  // 处理下一步
  handle() {
    switch (this.nextContent.type) {
      case UnitContentType.REPORT:
        // 学习报告
        window.location.href = this.nextContent.reportUrl;
        break;
      case UnitContentType.AIVideo:
        // 视频
        window.location.href = `${window.location.origin}/course/freedomVideo?courseId=${this.nextContent.courseId}&unitId=${this.nextContent.unitId}`;

        break;
      case UnitContentType.Homework:
        // 作业
        if (
          this.nextContent.homeworkLearnStatus
          === HOMEWORK_LEARN_STATUS.NOT_START
        ) {
          // 首次作答
          window.location.href = `${this.nextContent.homeworkUrl}?homeworkId=${this.nextContent.unitId}&type=${this.nextContent.homeworkLearnStatus}`;
        } else if (
          this.nextContent.homeworkLearnStatus
          === HOMEWORK_LEARN_STATUS.NOT_COMPLETE
        ) {
          // 未完成
          this.open();
        } else {
          window.location.href = `${this.nextContent.homeworkUrl}?homeworkId=${this.nextContent.unitId}`;
        }
        break;
      case UnitContentType.Material:
        // 视频
        window.location.href = this.nextContent.webviewJumpUrl || '';
        break;
      default:
        break;
    }
  }
}
